import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  IconButton,
  Box,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { BsFillPersonFill } from "react-icons/bs";
import CommanSpinner from "../components/CommanSpinner";

const AttachPatientDialog = ({
  attachPatient,
  attachPatientPopup,
  closePopup,
  processedData,
  currentPage,
  moveFaxToTrash,
  setMoveFaxToTrash,
  moveChildFaxToTrash,
  setMoveChildFaxToTrash,
  isLastChild,
  createPatientAndAttach,
  loader,
}) => {
  return (
    <>
      <Button variant="contained" onClick={(e) => attachPatient(e)}>
        ATTACH TO PATIENT
      </Button>

      <Dialog
        open={attachPatientPopup}
        onClose={closePopup}
        maxWidth="sm"
        fullWidth
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            onClick={closePopup}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogTitle sx={{ textAlign: "left", pt: 4 }}>
            Attach to Patient
          </DialogTitle>

          <DialogContent>
            <Box sx={{ mt: 2 }}>
              If you continue, this document will be attached to the patient
              specified below.
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <BsFillPersonFill />
                Patient Name: {
                  processedData?.patientKeyValues[0]?.labelValue
                }{" "}
                {processedData?.patientKeyValues[1]?.labelValue}
              </Typography>
            </Box>

            <Box sx={{ mt: 3 }}>
              {currentPage === "parent" ? (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={moveFaxToTrash}
                      onChange={() => setMoveFaxToTrash(!moveFaxToTrash)}
                      sx={{ "&.Mui-checked": { color: "#00AB4E" } }}
                    />
                  }
                  label="Remove fax from inbox"
                />
              ) : (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={moveChildFaxToTrash}
                      onChange={() =>
                        setMoveChildFaxToTrash(!moveChildFaxToTrash)
                      }
                      sx={{ "&.Mui-checked": { color: "#00AB4E" } }}
                    />
                  }
                  label={
                    isLastChild
                      ? "Move parent fax to trash as well"
                      : "Move child fax to trash"
                  }
                />
              )}
            </Box>
          </DialogContent>

          <DialogActions sx={{ p: 3, justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={closePopup}
              sx={{
                color: "#00AB4E",
                borderColor: "#00AB4E",
                "&:hover": {
                  borderColor: "#008C40",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => createPatientAndAttach("attach")}
              sx={{
                backgroundColor: "#00AB4E",
                "&:hover": {
                  backgroundColor: "#008C40",
                },
              }}
            >
              Attach
            </Button>
          </DialogActions>
        </Box>

        {/* {loader === "create&AttPatientLoader" && (
          <CommanSpinner spinner={loader} text="" />
        )} */}
      </Dialog>
    </>
  );
};

export default AttachPatientDialog;
